import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/card';
import { Heading } from '@art-of-hospitality-solutions-llc/ui-kit/components/heading';
import Breadcrumbs from '@Components/Breadcrumbs';
import { Link } from 'react-router-dom';

export default function Flows() {
  return (
    <div className="w-full">
      <Breadcrumbs navList={[{ name: 'Flows', href: '/flows' }]} />
      <div className="mt-8 mb-4 flex items-center justify-between">
        <div>
          <Heading>Flows</Heading>
          <p>Manage the flows within your organization.</p>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        <Card className="h-full">
          <CardHeader>
            <Heading level="h2">Flow Activity</Heading>
            <CardDescription>View and manage Flow Activity.</CardDescription>
          </CardHeader>
          <CardFooter>
            <Button asChild>
              <Link to="/flows/list">Flows</Link>
            </Button>
          </CardFooter>
        </Card>

        <Card className="h-full">
          <CardHeader>
            <Heading level="h2">Flow Builder</Heading>
            <CardDescription>
              Create new Flows. Edit existing ones.
            </CardDescription>
          </CardHeader>
          <CardFooter>
            <Button asChild>
              <Link to="/flows/builder">Flow Builder</Link>
            </Button>
          </CardFooter>
        </Card>

        <Card className="h-full">
          <CardHeader>
            <Heading level="h2">Flow Categories</Heading>
            <CardDescription>
              Create new Flow Categories. Edit existing ones.
            </CardDescription>
          </CardHeader>
          <CardFooter>
            <Button asChild>
              <Link to="/flows/categories">Flow Categories</Link>
            </Button>
          </CardFooter>
        </Card>

        <Card className="h-full">
          <CardHeader>
            <Heading level="h2">Category Cards</Heading>
            <CardDescription>
              Flow Activity organized by Flow Category.
            </CardDescription>
          </CardHeader>
          <CardFooter>
            <Button asChild>
              <Link to="/flows/cards">Category Cards</Link>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </div>
  );
}
